import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  NgZone,
  QueryList,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';

import { fabric } from 'fabric';
import { Image } from 'fabric/fabric-impl';
import { assignIn, min } from 'lodash-es';


@Component({
  selector: 'lib-thumbnail-pdf',
  imports: [
    CommonModule,
  ],
  templateUrl: './thumbnail-pdf.component.html',
  styleUrls: ['./thumbnail-pdf.component.scss']
})

export class ThumbnailPdfComponent implements AfterViewInit {
  @Input() printSettingsThumb: PrintSettingsThumb;
  @Input() pdfImages: string;
  @Input() settingsChanged;
  @ViewChildren('thumbContainer') thumbPages!: QueryList<ElementRef>;
  @ViewChild('pageContainer') pageContainer!: ElementRef;

  imgW = null;
  pagesCount = 0; //número de páginas del documento

  //CONTANTES
  longSide = 235; //LADO LARGO DE LA HOJA
  shortSide = 166; //LADO CORTO DE LA HOJA
  imageWidth = 1000; //TAMAÑO EN PIXELES DE LA IMÁGEN

  pdfSrc2: string;

  constructor(
    protected _zone: NgZone,
  ) {
  }

  ngOnChanges({ printSettingsThumb: _printSettingsThumb, pdfImages: _pdfImages }: SimpleChanges): void {
    const printSettingsThumb = _printSettingsThumb?.currentValue ?? this.printSettingsThumb;
    const pdfImages = _pdfImages?.currentValue ?? this.pdfImages;
    if (pdfImages && printSettingsThumb) {
      setTimeout(() => {
        this.setThumbHD(printSettingsThumb);
      }, 0);
    }
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
  }

  setOrientaction(o: 'portrait' | 'landscape') {
    let height, width;
    if (o === 'portrait') {
      height = this.longSide;
      width = this.shortSide;
    } else {
      height = this.shortSide;
      width = this.longSide;
    }

    return { height, width };
  }

  /******************************************************/
  /********************** Genera el thumb según seting  */
  /******************************************************/

  setThumbHD = async (settings: PrintSettingsThumb) => {

    //Determina si el documento es a color tomando en cuenta ambos valores 
    const isFileColor = settings.color === PrintColor.COLOR || settings.docColor;

    const aspectRatio = this.longSide / this.shortSide;
    //Fijamos la página principal
    const { height: pageHeight, width: pageWidth } = this.setOrientaction(
      settings.pageOrientation
    );
    const page = this.pageContainer.nativeElement;
    assignIn(page.style, {
      width: pageWidth + 'px',
      height: pageHeight + 'px',
    });

    //reinicamos los contenedores
    for (let i = 0; i < 4; i++) {
      const thumbPage = this.thumbPages.get(i).nativeElement;
      assignIn(thumbPage.style, {
        width: 0 + 'px',
        height: 0 + 'px',
        top: 0 + 'px',
        left: 0 + 'px',
      });
      const img = thumbPage.firstChild;
      assignIn(img.style, {
        width: 0 + 'px',
        height: 0 + 'px',
        top: 0 + 'px',
        left: 0 + 'px',
      });
      img.src = '';
    }
    //Creamos los contenedores
    const isCoverColor = !isFileColor && settings.coverColor;

    const pagesPerSheet: number = isCoverColor
      ? 1
      : (settings.pagesPerSheet as any) * 1;

    //Escala, esto se debería mejorar
    const fp =
      1 / (pagesPerSheet === 1 ? 1 : pagesPerSheet === 2 ? aspectRatio : 2);

    const isPortrait = settings.pageOrientation === PageOrientation.PORTRAIT;


    const pagesToShow = min([this.pdfImages.length, pagesPerSheet]);

    let top = 0,
      left = 0;
    for (let i = 0; i < pagesToShow; i++) {
      const thumbPage = this.thumbPages.get(i).nativeElement;
      let thumbPageWidth = pageWidth * fp;
      let thumbPageHeight = pageHeight * fp;
      if (pagesPerSheet == 2) {
        thumbPageWidth = pageHeight * fp;
        thumbPageHeight = pageWidth * fp;
      }

      assignIn(thumbPage.style, {
        width: thumbPageWidth + 'px',
        height: thumbPageHeight + 'px',
        top: top + 'px',
        left: left + 'px',
      });

      left = left + thumbPageWidth;
      if (left >= pageWidth) {
        top = top + thumbPageHeight;
        left = 0;
      }

      const img0 = await fabricImageFomrUrl(this.pdfImages[i]);
      const isImgPortrait = img0.height > img0.width;
      const rotationRequired =
        settings.autoRotate && isPortrait !== isImgPortrait;

      //Colocamos la imagen dentro de cada contenedor
      const imgPdf = this.pdfImages[i];
      //Se rota si está autorotacion y es distinto la orientacion
      let rotation = 0;
      if (settings.autoRotate && isPortrait !== isImgPortrait) {
        rotation =
          (!isImgPortrait && settings.pageTurn === PageTurn.LARGESIDE) ||
            (isImgPortrait && settings.pageTurn === PageTurn.SHORTSIDE)
            ? -90
            : 90;
      }
      //imagen
      const fitProperties = this.fitToPage({
        img: img0,
        isImgPortrait,
        rotation,
        thumbPageWidth,
        thumbPageHeight,
      });
      const img = thumbPage.firstChild;
      const grayscale = (!isFileColor && !isCoverColor) ? 1 : 0;

      assignIn(img.style, {
        width: fitProperties.width + 'px',
        height: fitProperties.height + 'px',
        top: fitProperties.top + 'px',
        left: fitProperties.left + 'px',
        transform: `rotate(${rotation}deg)`,
        filter: `grayscale(${grayscale})`
      });
      img.src = imgPdf;
    }
  };

  fitToPage(properties: any) {
    const { img, isImgPortrait: _isImgPortrait, thumbPageWidth, rotation, thumbPageHeight } =
      properties;

    const isThumbPortrait = thumbPageHeight > thumbPageWidth;
    const imgAspectRatio = img.height / img.width;

    const isImgPortrait = _isImgPortrait;
    let height = 0,
      width = 0,
      top = 0,
      left = 0;
    if (rotation) {
      if (isThumbPortrait) {
        width = thumbPageHeight;
        height = thumbPageHeight * imgAspectRatio;
        left = -1 * (thumbPageWidth - width) / -2;
        top = (thumbPageHeight - height) / 2;
      } else {

        height = thumbPageWidth;
        width = thumbPageWidth / imgAspectRatio;
        top = -1 * (thumbPageHeight - height) / -2;
        left = (thumbPageWidth - width) / 2;
      }

    } else {
      if (isImgPortrait) {
        height = thumbPageHeight;
        width = thumbPageHeight / imgAspectRatio;
        top = 0;
        left = (thumbPageWidth - width) / 2;
      } else {
        width = thumbPageWidth;
        height = thumbPageWidth * imgAspectRatio;
        left = 0;
        top = (thumbPageHeight - height) / 2;
      }
    }
    if (left < 0) {
      left = 0;
    }
    return { height, width, top, left };
  }
}

export enum PageOrientation {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}

export enum PrintColor {
  BLACKNWHITE = 'bn',
  COLOR = 'color',
}

export enum PagesPerSheet {
  ONE = '1',
  TWO = '2',
  FOUR = '4',
} // 6, 9, 16
export enum PageTurn {
  LARGESIDE = 'largeside',
  SHORTSIDE = 'shortside',
}

export interface PrintSettingsThumb {
  docColor: boolean;
  pageOrientation: PageOrientation;
  color: PrintColor;
  coverColor: boolean;
  pagesPerSheet: PagesPerSheet;
  autoRotate: boolean;
  pageTurn: PageTurn;
}

const fabricImageFomrUrl = (img): Promise<Image> => {
  return new Promise((resolve, reject) => {
    fabric.Image.fromURL(img, (_imgw) => {
      resolve(_imgw);
    });
  });
};

export function enumToArray(enumme: { [x: string]: any; }) {
  return Object.keys(enumme).map((key) => enumme[key]);
}
